/**
 * @flow
 * @relayHash 670547cf97160820cf7e69abe669cb0a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type H1IssueTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type H1IssueTable_RefetchQueryVariables = {|
  h1?: ?TextFilters,
  host: string,
  limit?: ?number,
  offset?: ?number,
  typeFilters?: ?$ReadOnlyArray<?string>,
  url?: ?TextFilters,
|};
export type H1IssueTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: H1IssueTable_project$ref
  |}
|};
export type H1IssueTable_RefetchQuery = {|
  variables: H1IssueTable_RefetchQueryVariables,
  response: H1IssueTable_RefetchQueryResponse,
|};
*/


/*
query H1IssueTable_RefetchQuery(
  $h1: TextFilters
  $host: String!
  $limit: Int
  $offset: Int
  $typeFilters: [String]
  $url: TextFilters
) {
  project(host: $host) {
    ...H1IssueTable_project_420GxB
    id
  }
}

fragment H1IssueTable_project_420GxB on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesH1Issues(h1: $h1, url: $url) {
          type
          severity
          count
        }
        h1Issues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, h1: $h1) {
          count
          edges {
            node {
              ...H1IssueRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment H1IssueRow_issue on H1Issue {
  id
  type
  severity
  h1s
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "h1",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "h1",
  "variableName": "h1",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "H1IssueTable_RefetchQuery",
  "id": null,
  "text": "query H1IssueTable_RefetchQuery(\n  $h1: TextFilters\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $typeFilters: [String]\n  $url: TextFilters\n) {\n  project(host: $host) {\n    ...H1IssueTable_project_420GxB\n    id\n  }\n}\n\nfragment H1IssueTable_project_420GxB on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesH1Issues(h1: $h1, url: $url) {\n          type\n          severity\n          count\n        }\n        h1Issues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, h1: $h1) {\n          count\n          edges {\n            node {\n              ...H1IssueRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment H1IssueRow_issue on H1Issue {\n  id\n  type\n  severity\n  h1s\n  url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "H1IssueTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "H1IssueTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "h1",
                "variableName": "h1",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "H1IssueTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesH1Issues",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "h1Issues",
                        "storageKey": null,
                        "args": [
                          v2,
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          },
                          v3
                        ],
                        "concreteType": "H1IssuesConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "H1IssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "H1Issue",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v4,
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "h1s",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd2aef5ff5d1e74028aa50342e0940646';
module.exports = node;
